import React from 'react';

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      <div className="map">
        <a href="https://www.openstreetmap.org/#map=16/50.2932/18.6619">
          <img src="resources/img/silesia.png" alt="" />
        </a>
      </div>
    </section>
  );
};

export default Contact;
